const PREFIX = "[wrpf/handoff]";

export const wrpfHandoffDebug = (...args: unknown[]): void => {
  if (typeof console !== "undefined") {
    console.debug(PREFIX, ...args);
  }
};

export const wrpfHandoffError = (...args: unknown[]): void => {
  if (typeof console !== "undefined") {
    console.error(PREFIX, ...args);
  }
};

export const maskTokenForLog = (token: string): string => {
  if (token.length <= 8) {
    return "***";
  }
  return `${token.slice(0, 4)}…${token.slice(-4)} (len=${token.length})`;
};
